import { Select } from "antd";
import React from "react";

export default function StylePicker(props) {

    const { value = null, onChange = () => { }, return_object = false } = props;


    const styles = [
        { id: 1, label: "Regular", weight: "normal", style: "normal" },
        { id: 2, label: "Italic", weight: "normal", style: "italic" },
        { id: 3, label: "Bold", weight: "bold", style: "normal" },
        { id: 4, label: "Bold Italic", weight: "bold", style: "italic" }
    ]

    
    // Intercept change to return either an id or full object
    const handleChange = (_id) => {
        if (return_object) {
            let _obj = styles.find(item => item.id === _id);
            if (_obj) {
                onChange(_obj);
                return;
            } else {
                // not found for some reason, return id in an empty object
                onChange({ id: _id });
                return;
            }
        } else {
            onChange(_id);
            return;
        }
    }

    // Draw styles
    const drawStyles = () => {
        return styles.map(item => {
            return (<Select.Option key={item.id} value={item.id}><div style={{ "fontStyle": item.style, "fontWeight": item.weight }}><small>{item.label}</small></div></Select.Option>)
        })
    }

    return (
        <Select value={(value) ? value : null} onChange={(e) => handleChange(e)} style={{ "borderBottom": "1px solid #eee", "width": "100%" }} bordered={true}>
            {drawStyles()}
        </Select>
    )
}